var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function FacebookBrand(_a) {
    var { size } = _a, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, Object.assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M18 9c0-4.968-4.032-9-9-9S0 4.032 0 9a8.99 8.99 0 0 0 7.6 8.889v-6.294H5.302V9H7.6V7.016c0-2.252 1.335-3.503 3.393-3.503.982 0 2.002.185 2.002.185v2.197h-1.13c-1.122 0-1.475.704-1.475 1.409V8.99h2.503l-.399 2.595H10.39v6.294A8.974 8.974 0 0 0 18 9z" }) })));
}
export default FacebookBrand;
